export default __webpack_public_path__ + "de1d02ff.woff";